import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {history} from 'fn-common-ui';
import {Link} from 'react-router-dom';
import {NewTabLink} from 'fn-common-ui';

import config from 'config';

@observer
export class Footer extends React.Component {

  static propTypes = {
    showPrivateLinks: PropTypes.bool,
    store: PropTypes.object.isRequired
  }

  static defaultProps = {
    showPrivateLinks: true
  }

  constructor(props) {
    super(props);
    this.joyrideStore = this.props.store.joyrideStore;
  }

  onContactUs = () => {
    history.push("/contact");
  }

  handleToggleWalkthrough = (event) => {
    event.preventDefault();
    this.joyrideStore.toggleTour();
  }

  renderFirstNetColumn() {
    return (<div className="col-12 col-md-4">
      <nav aria-labelledby="firstnet-sites">
        <h2 id="firstnet-sites">Firstnet Sites</h2>
        <ul>
          <li>
            <NewTabLink to={config.firstNetComHome}>FirstNet.com</NewTabLink>
          </li>
          <li>
            <NewTabLink to={config.devPortal}>Developer Portal</NewTabLink>
          </li>
          <li>
            <NewTabLink to={config.firstnetTraining}>Quick Help & Tutorials</NewTabLink>
          </li>
        </ul>
      </nav>
    </div>);
  }

  renderSocialLinkColumn() {
    return (<div className="col-12 col-md-4">
      <nav className="social-nav" aria-describedby="social-links">
        <h2 id="social-links">Follow Us</h2>
        <ul className="social-links-list">
          <li>
            <NewTabLink to={config.firstNetFacebook} className="fn-social-icon fb">
              <i aria-hidden="true" className="icon-facebook"></i>
              <span className="title">Facebook</span>
            </NewTabLink>
          </li>
          <li>
            <NewTabLink to={config.firstNetLinkedIn} className="fn-social-icon linkedin">
              <i aria-hidden="true" className="icon-linkedin"></i>
              <span className="title">LinkedIn</span>
            </NewTabLink>
          </li>
          <li>
            <NewTabLink to="https://x.com/firstnet" className="fn-social-icon x">
              <i aria-hidden="true" className="icon-x"></i>
              <span className="title">X</span>
            </NewTabLink>
          </li>
          <li>
            <NewTabLink to={config.firstNetYouTube} className="fn-social-icon youtube">
              <i aria-hidden="true" className="icon-youtube"></i>
              <span className="title">YouTube</span>
            </NewTabLink>
          </li>
        </ul>
      </nav>
    </div>);
  }

  renderHelpColumn() {
    return (<div className="col-12 col-md-4">
      <nav aria-describedby="helpLinks">
        <h2 id="helpLinks" className="help-hdr">
          <i className="icon-help white" aria-hidden="true"/>
          Help
        </h2>
        <ul className="help-link-block">
          {this.props.showPrivateLinks &&
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
          }

          {this.props.showPrivateLinks &&
            <li>
              <a href="#" role="button" className="walkthru-toggle as-table-cell" onClick={this.handleToggleWalkthrough}>
                {`${this.joyrideStore.tourIsDisabled
                  ? 'Enable'
                  : 'Disable'} Site Walkthrough`
                }
              </a>
            </li>
          }
          <li>
            <NewTabLink className="as-table-cell" to={config.devCertificationAccrediation}>
              FirstNet App Review
              <br/>
              Process Help
            </NewTabLink>
          </li>
          {this.props.showPrivateLinks &&
            <li>
              <button role="link" onClick={this.onContactUs} className="btn fn-inverse contact-us-button">
                Contact Us
              </button>
            </li>
          }
        </ul>
      </nav>
    </div>);
  }

  renderBottomNav() {
    return (<nav>
      <ul className="sub-links">
        <li>
          <NewTabLink to={config.firstNetPrivacy}>
            Privacy Policy
          </NewTabLink>
        </li>
        <li>
          <NewTabLink to={config.firstNetTermsConditions}>
            Terms and Conditions
          </NewTabLink>
        </li>
        <li className="xs-line-break"></li>
        <li>
          <NewTabLink to={config.firstNetAccessibility}>
            Accessibility
          </NewTabLink>
        </li>
        <li>
          <NewTabLink to={config.firstNetGovHome}>
            FirstNet.gov
          </NewTabLink>
        </li>
        <li className="xs-line-break"></li>
        <li>
          <NewTabLink to={config.firstNetDoNotSell} className='privacy-choices'>
            Your Privacy Choices 
          </NewTabLink>
          <img src="./images/privacyoptions.svg" alt="California Consumer Privacy Act (CCPA) Opt-Out Icon" style={{width: '1.5em'}}/>
        </li>
      </ul>
    </nav>);
  }

  render() {
    return (<div className="footer-container">
      <footer className="dev-console-footer" id="dev-console-footer">
        <div className="footer-main">
          <div className="container">
            <div className="row">
              <div className="col-12 logoRow">
                {
                  this.props.showPrivateLinks
                    ? <Link to="/" className="logo-home-link-footer">
                        <img src="/images/firstnet-logo-white.svg" alt="FirstNet Built with AT&T"/>
                        <span className="sr-only">Go Home</span>
                      </Link>
                    : <img src="/images/firstnet-logo-white.svg" alt="FirstNet Built with AT&T" />
                }
              </div>
            </div>
            <div className="row is-flex">
              {this.renderFirstNetColumn()}
              {this.renderSocialLinkColumn()}
              {this.renderHelpColumn()}
            </div>
          </div>
        </div>
        <div className="footer-sub">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {this.renderBottomNav()}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>);
  }
}
